import { SimpliCitySDK } from "cms/sdk";
import { useEffect, useState } from "react";
import { useAuth } from "cms/auth/hooks/useAuth";


const useFeed = (input) => {

    const { term, type, category, categoryName, quantity, range } = input || {};
    const { token } = useAuth();
    const [models, setModels] = useState([]);
    const [pagination, setPagination] = useState();
    const [loaded, setLoaded] = useState(false);

    const fetchFeed = async (_token, _quantity, timer) => {
        const page = 1;
        const pageSize = _quantity;
        const options = { page, pageSize, type, term, category, categoryName, range };
        const {
            pagination: _pagination,
            results: _models
        } = await SimpliCitySDK.model.findFeed(token, options);
        setModels(_models);
        setPagination(_pagination);
        setLoaded(true);
        clearInterval(timer);
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            if (!loaded) {
                setLoaded(true);
            }
        }, 12000);
        fetchFeed(token, quantity, timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, quantity]);


    return {
        models, pagination, loaded
    };
};

export { useFeed };
